// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"177":"4f60f243","443":"50efee22","502":"e0f6ef19","851":"263d0a45","915":"d4cd3567"}[chunkId] + ".js";
};